module.exports = __webpack_public_path__ + "static/media/addFull.af013f64.svg";